/* luxury-newsletter-popup.js */

class LuxuryNewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.luxury-popup-overlay');
    this.closeBtn = this.querySelector('.luxury-popup-close');
    this.form = this.querySelector('form');
    this.storageKey = 'naap_newsletter_seen';
    
    // Check if form was just successfully submitted (Shopify reloads page)
    const urlParams = new URLSearchParams(window.location.search);
    const formSubmitted = urlParams.get('customer_posted') === 'true' || this.querySelector('.luxury-popup-success');

    if (formSubmitted) {
      sessionStorage.setItem(this.storageKey, 'true');
      return; // Do not show if just submitted
    }

    if (!sessionStorage.getItem(this.storageKey)) {
      this.init();
    }
  }

  init() {
    // Delay entrance by 3 seconds for a premium feel
    setTimeout(() => {
      this.show();
    }, 3000);

    this.closeBtn.addEventListener('click', () => this.hide());
    
    // Close on overlay click
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.hide();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay.classList.contains('is-visible')) {
        this.hide();
      }
    });
  }

  show() {
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  hide() {
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    sessionStorage.setItem(this.storageKey, 'true');
  }
}

customElements.define('luxury-newsletter-popup', LuxuryNewsletterPopup);
